export default "__VITE_ASSET__CswWFy$G__"